function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { onResize } from '../../../index';
import '../polyfill/wdh-nodelist-foreach';

var WDHEqualHeight = /*#__PURE__*/function () {
  function WDHEqualHeight() {
    var _this = this;

    _classCallCheck(this, WDHEqualHeight);

    this.selectors = [];
    this.callbacks = [];
    onResize(function () {
      _this.execute();
    });
  }

  _createClass(WDHEqualHeight, [{
    key: "execute",
    value: function execute() {
      for (var i = 0, len = this.selectors.length; i < len; i += 1) {
        var height = this.equalheight(this.selectors[i]);
        var callback = this.callbacks[i];
        callback(height);
      }
    }
  }, {
    key: "register",
    value: function register(nodeList, ignoreLineBreak, callback) {
      this.equalheight({
        nodeList: nodeList,
        ignoreLineBreak: ignoreLineBreak
      });
      this.selectors.push({
        nodeList: nodeList,
        ignoreLineBreak: ignoreLineBreak
      });

      if (this.callback !== undefined) {
        this.callbacks.push(callback);
      } else {
        this.callbacks.push(function () {});
      }
    }
  }, {
    key: "trigger",
    value: function trigger(nodeList, ignoreLineBreak, callback) {
      var height = this.equalheight({
        nodeList: nodeList,
        ignoreLineBreak: ignoreLineBreak
      });

      if (callback !== undefined) {
        callback(height);
      }
    }
  }, {
    key: "equalheight",
    value: function equalheight(data) {
      var currentTallest = 0;
      var currentRowStart = 0;
      var rowDivs = [];
      var topPosition = 0;
      var currentDiv;
      var nodeList = data.nodeList;
      var ignoreLineBreak = data.ignoreLineBreak;
      nodeList.forEach(function (node) {
        node.style.height = 'auto';
      });
      nodeList.forEach(function (node) {
        topPosition = node.offsetTop;

        if (currentRowStart !== topPosition && ignoreLineBreak !== true) {
          for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv += 1) {
            rowDivs[currentDiv].style.height = "".concat(currentTallest, "px");
          }

          rowDivs.length = 0; // empty the array

          currentRowStart = topPosition;
          currentTallest = node.offsetHeight;
          rowDivs.push(node);
        } else {
          rowDivs.push(node);

          if (currentTallest < node.offsetHeight) {
            currentTallest = node.offsetHeight;
          }
        }
      });

      for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv += 1) {
        rowDivs[currentDiv].style.height = "".concat(currentTallest, "px");
      }

      return currentTallest;
    }
  }]);

  return WDHEqualHeight;
}();

var equalHeight = new WDHEqualHeight();

var triggerEqualHeight = function triggerEqualHeight() {
  equalHeight.trigger.apply(equalHeight, arguments);
};

var registerEqualHeight = function registerEqualHeight() {
  equalHeight.register.apply(equalHeight, arguments);
};

export { triggerEqualHeight, registerEqualHeight };